import { object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  id: string().required(),
  form_answer_id: string().required(),
  stage_id: string().required().nullable(),
  user_id: string().defined().nullable(),
});

/**
 * CardFieldAnsweredEvent
 *
 * - Evento emitido quando um campo de card é respondido.
 */
export class CardFieldAnsweredEvent extends CreateCommand(
  RealtimeEventType.CardFieldAnswered,
  SCHEMA,
) {}
